import { GlintsChatAssetProperties } from './asset-properties';
import { GlintsChatMemberContactRequest } from './member';

export const GlintsChatExchangeRequestStatus = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  DONE: 'DONE',
} as const;

export type GlintsChatExchangeRequestStatus =
  (typeof GlintsChatExchangeRequestStatus)[keyof typeof GlintsChatExchangeRequestStatus];

type GlintsChatExchangeRequest = {
  requestUserID: string;
  status: GlintsChatExchangeRequestStatus;
  messageID?: string;
  respondentUserID?: string;
  file?: GlintsChatAssetProperties;
  contact?: GlintsChatMemberContactRequest;
};

export type GlintsChatChannelExchangeRequest = {
  cv?: GlintsChatExchangeRequest;
  contact?: GlintsChatExchangeRequest;
};
